import jsPDF from 'jspdf';
import moment from 'moment-timezone';

export function ExportPdf(ClaimsDetails, ExportUser) {
  var doc = new jsPDF('p', 'pt');

  for(var i=0; i<ClaimsDetails.length;i++) {
    let imageprint = ClaimsDetails[i].Img.replace('https', 'http')
    doc.addImage(imageprint, 'PNG', 50, 50, 500, 650)

    const Checklength = ClaimsDetails.length - 1
    if(Checklength !== i) {
      doc.addPage()
    }
    // doc.addPage()
  }
  doc.save(`Receipt-${moment(new Date()).format('DD-MM-YYYY HH:mm:ss')}/${ExportUser}.pdf`)
}
